import React, { useState } from "react";
import { KTSVG } from "../../../helpers";

type Props = {
  className: string;
  innerPadding?: string;
};

const StepContent14: React.FC<Props> = ({ className, innerPadding = "" }) => {
  const [category, setCategory] = useState("1");
  const [option, setOption] = useState("1");
  const [fleet, setFleet] = useState("1");
  return (

      <div className={`card ${className}`}>
        {/* begin::Body */}
        <div className={`card-body ${innerPadding}`}>
          {/* begin::Title */}
          <div className="mb-10">
            <h3 className="fw-bold text-dark mb-2 fs-3">Calculate TAM for follow-on markets</h3>
            <span className="fs-7 text-muted">
             Read each section and then fill in your answers at the bottom.
            </span>
          </div>
          {/* end::Title */}

          {/* begin::Section */}
          <div className="mb-10">
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-7 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    Calculate TAM for follow-on markets
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  In this step, you will briefly consider which “follow-on” markets you will expand to after dominating your beachhead market, then calculate the size and growth rates of these follow-on markets.

While maintaining a relentless daily focus on your beachhead market, at this point we ask you to pick your head up temporarily to briefly revisit the big picture. We want to make sure that we win a market that is worth winning. This avoids the “Playing Checkers” mentality, which we define as only thinking one step ahead. You want to have the "Playing Chess" mentality— several moves ahead in your market. To do that, in this step we ask you to do a small amount of analysis on what happens if and when you win the beachhead market, from a general standpoint and without a great deal of detail.

What do you project will be your next markets to be?
How big do you estimate that they will be?
What will be your USP (Unique Selling Proposition) in these markets?
Is it consistent with your core?
Is it consistent with the skills and assets you will be developing in your beachhead market?
This is simply a check to make sure you are heading in the right direction to build a scalable business and also a reminder of the size and nature of the bigger opportunity. Once this glimpse into your future is done, it is very important that you do not let the lure of the broader market and awesome TAM calculation distract you and your team from the beachhead market.

The broader TAM calculation should galvanize the team to conquer the beachhead market first— and faster— while, keeping the team thinking about the importance of developing and growing the Core business.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Identify the follow-on markets and TAM
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  DUse the same general methodology to calculate the TAM for each follow-on market that you did for your beachhead TAM in Step 4. If you want to attract venture capital and/or build a big business, the general rule is that the broader TAM (for 10 or less follow-on markets) plus your beachhead market TAM should add up to over $ 1B. These numbers need not be as precise as the calculation in Step 4 nor should they be. This is a much rougher calculation.

Identify between 5 and 10 follow-on markets based on the strategy/strategies you choose: Upselling (selling the same customer additional products or application, and using existing sales and distribution channels to sell the new products, thereby leveraging the investment and positive relationship you built with the target customer) or/and Adjacent markets (selling the same basic product to other markets similar to your beachhead. This may require additional features, product refinement, and/or different packaging, marketing communications, or pricing, but you are leveraging the same Core, and building off the expertise and scale developed in the beachhead market).
Identify the TAM for each follow-on market, based on the principles in Step 4.
Identify factors to help you estimate the compounded annual growth rate (CAGR) for each of those markets.
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* end::Section */}

        </div>
        {/* end: Card Body */}
      </div>
      
  );
};

export { StepContent14 };
